import { Stack } from "@mui/material";
import FilterChip from "../../Admin/Chip/FilterChip";
import { useBoundStore } from "useStore";
import useStateData from "../../Queries/stateDataQuery";
import { useContext } from "react";
import { AppGlobalContext } from "contexts/GlobalContext";

const DEFAULT_ESTADO_ID = 2;

export default function StateFilterChip() {
  const { mainCountry } = useContext(AppGlobalContext);
  const stateDataQuery = useStateData({ countryId: mainCountry?.id });
  const selectedStatus = useBoundStore((state) => state.soTallerSelectedStatus);

  const statusData = stateDataQuery.data ?? [];
  const defaultStatus =
    statusData.find((s) => s.id === DEFAULT_ESTADO_ID) ?? statusData[0] ?? null;
  const displayStatus = selectedStatus ?? defaultStatus;

  if (!displayStatus) return null;

  return (
    <Stack direction="row" flexWrap="wrap" gap={1}>
      <FilterChip filterName="Estado" title={displayStatus.nombre_estado} />
    </Stack>
  );
}
